module.exports = __webpack_public_path__ + "d0b8831e9983054cbc17697284bd54eb.png";